function mobileNav() {
  // Check for click events on the navbar burger icon
  $(".navbar-burger").click(function () {
    // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
    $(".navbar-burger").toggleClass("is-active")
    $(".navbar-menu").toggleClass("is-active")
    return false
  })
}

function servicesDropdown() {
  $(".navbar-link[data-dropdown='services-link']").click(function () {
    $(".navbar-item[data-dropdown='services']").toggleClass("is-active")
    return false
  })
}

function smoothScroll(trig, dest, adjustment) {
  adjustment = adjustment || 0
  $(trig).click(function (e) {
    e.preventDefault()
    $("html, body").animate(
      { scrollTop: $(dest).offset().top + adjustment },
      1000
    )
    return false
  })
}

function closeNotifications() {
  $(".notification > button.delete").click(function () {
    $(this).parent().addClass("is-hidden")
    return false
  })
}

function slideDownReveal(trig, dest, duration) {
  duration = duration || 700
  $(trig).click(function () {
    $(this).children().toggleClass("is-flipped")
    $(dest).slideToggle(duration)
    console.log(duration)
  })
}

$(function () {
  mobileNav()
  smoothScroll("#nav-services", "#services")
  smoothScroll(
    "#services-go-to-residential",
    "#services-residential-landing",
    -50
  )
  smoothScroll(
    "#services-go-to-commercial",
    "#services-commercial-landing",
    -50
  )
  smoothScroll(
    "#services-go-to-government",
    "#services-government-landing",
    -50
  )
  smoothScroll("#faqs-go-to-faqs", "#faqs-landing")
  smoothScroll("#solar-header-btn", "#lead-contact")
  smoothScroll("#solar-cta-btn", "#lead-contact")
  smoothScroll("#solar-tax-btn", "#lead-contact")
  servicesDropdown()
  closeNotifications()

  $(
    ".modal-close, .modal-background, .close-modal, .modal-card-head .delete"
  ).click(function (e) {
    e.preventDefault()
    $(this).closest(".modal").removeClass("is-active")
  })
})
